import React, { Component } from 'react';
import NRICInput from '../../components/ui/forms/NRICInput';
import NRICWrap from '../../components/ui/forms/NRICWrap';
import Label from '../../components/ui/forms/Label';
import Button from '../ui/Button';

class NRICLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            otp1: '',
            otp2: '',
            otp3: '',
            otp4: '',
            otp5: '',
            otp6: '',
        }
    }

    componentDidUpdate(prevProps, previousState) {
        if(previousState.otp1 !== this.state.otp1 ||
            previousState.otp2 !== this.state.otp2 ||
            previousState.otp3 !== this.state.otp3||
            previousState.otp4 !== this.state.otp4||
            previousState.otp5 !== this.state.otp5||
            previousState.otp6 !== this.state.otp6){
            this.setState({
                otp1:this.props.state.otp1,
                otp2:this.props.state.otp2,
                otp3:this.props.state.otp3,
                otp4:this.props.state.otp4,
                otp5:this.props.state.otp5,
                otp6:this.props.state.otp6
            })
        }
    }

    
    handleChange = (e) => {
        this.props.handleChange(e);
        const name = e.target.name,
            val = e.target.value;
            this.setState({
                [name]: val
            },() => {
            if (name === 'nric1') {
                if ((val.length === 1)) {
                    this.refs.nric2.focus();
                }
            }
            if (name === 'nric2') {
                if ((val.length === 1)) {
                    this.refs.nric3.focus();
                }
            }
            if (name === 'nric3') {
                if ((val.length === 1)) {
                    this.refs.nric4.focus();
                }
            }
        });
    }

    onKeyNRIC2 = (e) => {
        let key = e.keyCode || e.charCode;

        if ((key === 8 || key === 46) && (this.state.nric2 === '')) {
            this.refs.nric1.focus();
        }
    }

    onKeyNRIC3 = (e) => {
        let key = e.keyCode || e.charCode;

        if ((key === 8 || key === 46) && (this.state.nric3 === '')) {
            this.refs.nric2.focus();
        }
    }

    onKeyNRIC4 = (e) => {
        let key = e.keyCode || e.charCode;

        if ((key === 8 || key === 46) && (this.state.nric4 === '')) {
            this.refs.nric3.focus();
        }
    }

    onFocusNRIC4 = (e) => {
        if ((this.state.nric4 === "") && (this.state.nric3 === "") && (this.state.nric2 === "")) {
            this.refs.nric3.focus();
        }
    }

    onFocusNRIC3 = (e) => {
        if ((this.state.nric3 === "") && (this.state.nric1 === "") && (this.state.nric2 === "")) {
            this.refs.nric2.focus();
        }
    }

    onFocusNRIC2 = (e) => {
        if ((this.state.nric2 === "") && (this.state.nric1 === "")) {
            this.refs.nric1.focus();
        }
    }

    render() {  
        const { state, isNRICButtonDisabled } = this.props;
        return (
            <>
            <div data-test-id = 'nricLogin'>
                <div>
                    This is a finance application with {this.props.financialService} Singapore. <br /> <br />
                    To proceed with your finance application, please enter the last 4 characters of your NRIC (e.g. 123A)
                </div>
                <NRICWrap>
                    <NRICInput
                        className="input_nric"
                        ref="nric1"
                        onChange={this.handleChange}
                        type="tel"
                        maxlength="1"
                        value={state.nric1}
                        name="nric1"
                    />
                    <NRICInput
                        className="input_nric"
                        ref="nric2"
                        onChange={this.handleChange}
                        onKeyDown={this.onKeyNRIC2}
                        onFocus={this.onFocusNRIC2}
                        type="tel"
                        value={state.nric2}
                        name="nric2" />
                    <NRICInput
                        className="input_nric"
                        ref="nric3"
                        onChange={this.handleChange}
                        onKeyDown={this.onKeyNRIC3}
                        onFocus={this.onFocusNRIC3}
                        type="tel"
                        value={state.nric3}
                        name="nric3" />
                    <NRICInput
                        className="input_nric"
                        ref="nric4"
                        onChange={this.handleChange}
                        onKeyDown={this.onKeyNRIC4}
                        onFocus={this.onFocusNRIC4}
                        type="text"
                        value={state.nric4}
                        name="nric4" />
                </NRICWrap>
                {
                    <Button
                        disabled={isNRICButtonDisabled}
                        onClick={() => this.props.onCheckNRIC()}
                        data-test-id="checkNRIC"
                        >
                        Next
                    </Button>
                }
                {(state.showError === true && this.props.errorNricValid !== '' &&
                    state.nric4 && state.nric3 && state.nric2 && state.nric1) &&
                    <Label isError name="nricvaliderror">
                        {this.props.errorNricValid}
                    </Label>
                }
            </div> 
            </>
        );
    }
}


export default NRICLogin;
